import { bffAuthClient } from './bffAuthClient'
import type {
    AuthenticatedResponse,
    DeviceForgetRequest,
    DeviceForgetResponse,
    DeviceTrustRequest,
    DeviceTrustResponse,
    LoginChallengeRequest,
    LoginChallengeResponse,
    LoginDeviceChallengeRequest,
    LoginDeviceChallengeResponse,
    LoginDeviceVerifyRequest,
    LoginRequest,
    LoginResponse,
    LogoutResponse,
    RefreshResponse,
} from '@six-invest/api-types/auth/types'
import type {
    ForgotPasswordConfirmRequest,
    ForgotPasswordConfirmResponse,
    ForgotPasswordRequest,
    ForgotPasswordResponse,
} from '../types'

export const bffAuthApi = {
    async login(request: LoginRequest): Promise<LoginResponse> {
        const { data } = await bffAuthClient.post<LoginResponse>('/auth/login', request)
        return data
    },
    async loginChallenge(request: LoginChallengeRequest): Promise<LoginChallengeResponse> {
        const { data } = await bffAuthClient.post<LoginChallengeResponse>('/auth/login/challenge', request)
        return data
    },
    async refresh(): Promise<RefreshResponse> {
        const { data } = await bffAuthClient.post<RefreshResponse>('/auth/refresh')
        return data
    },
    async logout(): Promise<LogoutResponse> {
        const { data } = await bffAuthClient.post<LogoutResponse>('/auth/logout')
        return data
    },
    async loginDeviceChallenge(request: LoginDeviceChallengeRequest): Promise<LoginDeviceChallengeResponse> {
        const { data } = await bffAuthClient.post<LoginDeviceChallengeResponse>('/auth/login/device-challenge', request)
        return data
    },
    async loginDeviceVerify(request: LoginDeviceVerifyRequest): Promise<AuthenticatedResponse> {
        const { data } = await bffAuthClient.post<AuthenticatedResponse>('/auth/login/device-verify', request)
        return data
    },
    async deviceTrust(request: DeviceTrustRequest): Promise<DeviceTrustResponse> {
        const { data } = await bffAuthClient.post<DeviceTrustResponse>('/auth/device/trust', request)
        return data
    },
    async deviceForget(request: DeviceForgetRequest): Promise<DeviceForgetResponse> {
        const { data } = await bffAuthClient.post<DeviceForgetResponse>('/auth/device/forget', request)
        return data
    },
    async forgotPassword(request: ForgotPasswordRequest): Promise<ForgotPasswordResponse> {
        const { data } = await bffAuthClient.post<ForgotPasswordResponse>('/auth/forgot-password', request)
        return data
    },
    async forgotPasswordConfirm(request: ForgotPasswordConfirmRequest): Promise<ForgotPasswordConfirmResponse> {
        const { data } = await bffAuthClient.post<ForgotPasswordConfirmResponse>(
            '/auth/forgot-password/confirm',
            request,
        )
        return data
    },
}
